<app-go-navigation>
    <app-masquerade-header [topMarginClass]="'-mt-4'"></app-masquerade-header>
    <div
        id="content"
        class="relative mx-auto max-w-lg py-4 space-y-4"
        [class.pointer-events-none]="loading$ | async"
    >
        <div class="flex flex-col space-y-4">
            <router-outlet></router-outlet>
            <app-go-application-page-navigation></app-go-application-page-navigation>
        </div>

        @if (loading$ | async) {
            <app-loading></app-loading>
        }
    </div>
</app-go-navigation>
